import AutomatedCatalogCarouselCardDesktop from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/DesktopCard/AutomatedCatalogCarouselCardDesktop';
import AutomatedCatalogCarouselCardMobile from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/MobileCard/AutomatedCatalogCarouselCardMobile';
import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';

type Props = {
    catalogId: number;
    width: number;
};

const AutomatedCatalogCarouselCard = (props: Props) => {
    const isMobile = useIsMobileLayout();

    if (isMobile) {
        return <AutomatedCatalogCarouselCardMobile {...props} />;
    }

    return <AutomatedCatalogCarouselCardDesktop catalogId={props.catalogId} />;
};

export default AutomatedCatalogCarouselCard;
